import { CALL_API } from 'redux-api-middleware'
import { FORGOT_PASSWORD_RESET_RECEIVE } from './authProfile';

const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'

export const FORGOT_PASSWORD_PROFILE_REQUEST = 'forgotPassword/FORGOT_PASSWORD_PROFILE_REQUEST'
export const FORGOT_PASSWORD_PROFILE_RECEIVE = 'forgotPassword/FORGOT_PASSWORD_PROFILE_RECEIVE'
export const FORGOT_PASSWORD_PROFILE_FAILURE = 'forgotPassword/FORGOT_PASSWORD_PROFILE_FAILURE'

const initialState = {
  completed: false,
  hasReceivedUserInfo: false,
  partner: '',
  securityQuestion: '',
  userId: ''
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      const pathname = action.payload.pathname
      let userId = ''
      if (pathname.includes('/forgot-password/')) {
        userId = atob(pathname.match(/forgot-password\/(.*)/)[1])
      }
      return {
        ...state,
        userId
      }
    case FORGOT_PASSWORD_PROFILE_RECEIVE:
      return {
        ...state,
        partner: action.payload.data.item.partners ? action.payload.data.item.partners.map(partner => partner.name).join() : '',
        securityQuestion: action.payload.data.item.recoveryQuestion,
        hasReceivedUserInfo: true
      }
    case FORGOT_PASSWORD_RESET_RECEIVE:
      return {
        ...state,
        completed: true
      }
    default:
      return state
  }
}

export function fetchForgotPasswordUser(userId) {
  let localEndpoint
  if (isLocal()) {
    userId = userId === '' ? 'mockedUser' : userId
    localEndpoint = window.location.search.includes('?user_type=mockedPAUserNoRecoveryQuestion') ? `/api/v1/authz/users/${userId}/NoRecoveryQuestion` : `/api/v1/authz/users/${userId}`
  }
  return {
    [CALL_API]: {
      endpoint: isLocal() ? `http://localhost:8080${localEndpoint}` :
        `/api/v1/authz/users/${userId}`,
      method: 'GET',
      credentials: 'include',
      types: [FORGOT_PASSWORD_PROFILE_REQUEST, FORGOT_PASSWORD_PROFILE_RECEIVE, FORGOT_PASSWORD_PROFILE_FAILURE]
    }
  }
}

function isLocal() {
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
}

export default reducer
